import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  slot: "start",
  class: "icon-width"
}
const _hoisted_2 = { class: "purple-purple-color" }
const _hoisted_3 = {
  slot: "content",
  class: "light-light-background"
}
const _hoisted_4 = {
  slot: "start",
  class: "icon-width"
}
const _hoisted_5 = { class: "purple-purple-color" }
const _hoisted_6 = {
  slot: "content",
  class: "px-3 pb-3 pt-1 purple-purple-color light-light-background"
}
const _hoisted_7 = { class: "center-x pt-3" }
const _hoisted_8 = {
  slot: "start",
  class: "icon-width"
}
const _hoisted_9 = { slot: "content" }
const _hoisted_10 = {
  slot: "start",
  class: "icon-width"
}
const _hoisted_11 = {
  slot: "content",
  class: "px-3 pb-3 pt-1 purple-purple-color light-light-background"
}

import { ref as _ref, computed as _computed } from 'vue';

import {
    IonAccordion,
    IonAccordionGroup,
    IonIcon,
    IonItem,
    IonToggle,
    loadingController,
    modalController
} from "@ionic/vue";
import { nextTick, onMounted } from "vue";
import router, { route } from "@/router";
import { t } from "@/plugins/vue-i18n";
import { pingRequest } from "@/api-connectors/basicRequests";
import { IonToggleCustomEvent, ToggleChangeEventDetail } from "@ionic/core";

import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import OrderNotificationTimer from "@/components/popover/OrderNotificationTimer.vue";
import FilterHeader from "@/components/modal/FilterHeader.vue";
import FilterInterface from "@/components/modal/FilterInterface.vue";

import { useUserStore } from "@/stores/user";
import { usePersistentStore } from "@/stores/persistent";
import { useListStore } from "@/stores/lists";
import { useSupplierStore } from "@/stores/suppliers";

import { useAlert } from "@/composables/useAlert";
import { useLoader } from "@/composables/useLoader";
import { useCatalogFilter } from "@/composables/viewFunctions/useCatalogFilter";

import { isApp } from "@/functions/enviroment";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { PERMISSION_KEY } from "@/types/user";
import { GetListItemsParams } from "@/types/list";
import { SORT_METHOD } from "@/types/enum/propEnum";

import { alarmOutline } from "ionicons/icons";
import ButtonBase from "@/components/button/ButtonBase.vue";
import * as repl from "repl";
import { replaceToast } from "@/functions/baseToast";
import { popAlertConfirm } from "@/functions/alert";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListSettingsModal',
  props: {
    supplierId: {}
  },
  setup(__props: any) {
const props = __props

const userStore = useUserStore()
const persistentStore = usePersistentStore()
const listStore = useListStore()
const supplierStore = useSupplierStore()
const { showLoading, hideLoading } = useLoader()

const tempCategory = _ref<Record<string, boolean>>(JSON.parse(JSON.stringify(listStore.listFilter.category)))
const tempTags = _ref<Record<string, boolean>>(JSON.parse(JSON.stringify(listStore.listFilter.tags)))
const tempSortDirection = _ref<SORT_METHOD>(listStore.listFilter.sortDirection)
const withQuantity = _ref<boolean>(JSON.parse(JSON.stringify(listStore.listFilter.withQuantity)))
let forceReload = _ref<number>(0)

const listId = _computed<string>(() => route.value.params.listId as string)
const locationId = _computed<string>(() => route.value.params.locationId as string)
const list = _computed(() => listStore.listById(listId.value))

const { getCatalogItems } = useCatalogFilter(listId.value)

const resetChanges = async (): Promise<void> => {
    if (!listId.value) {
        supplierStore.catalogFilter.sortDirection = SORT_METHOD.ALPH_ASC
    } else {
        listStore.listFilter.sortDirection = SORT_METHOD.MANUAL
    }
    listStore.listFilter.category = {}
    listStore.listFilter.tags = {}
    listStore.listFilter.withQuantity = false

    if (!isApp()) {
        await modalController.dismiss()
        return
    }

    await showLoading()
    await getCatalogItems(props.supplierId)
    if (await loadingController.getTop()) hideLoading()
    if (await modalController.getTop()) modalController.dismiss()
}

const applyChanges = async (): Promise<void> => {
    listStore.listFilter.sortDirection = tempSortDirection.value
    listStore.listFilter.tags = tempTags.value
    listStore.listFilter.category = tempCategory.value
    listStore.listFilter.withQuantity = withQuantity.value

    if (!isApp()) {
        await modalController.dismiss()
        if (tempSortDirection.value === SORT_METHOD.MANUAL) await listStore.getManualSortList(listId.value)
        return
    }

    await showLoading()
    if (tempSortDirection.value === SORT_METHOD.MANUAL) await listStore.getManualSortList(listId.value)
    await getCatalogItems(props.supplierId, undefined, true)
    await listStore.getListItems(new GetListItemsParams({
        locationId: locationId.value,
        listId: listId.value,
        searchKey: supplierStore.searchQuery !== '' ? supplierStore.searchQuery : undefined,
        // category: listStore.activeCategoriesIds.length !== 0 ? listStore.listFilter.category : undefined,
        tags: listStore.activeFiltersIds.length !== 0 ? listStore.activeFiltersIds.join(',') : undefined,
        withQuantity: listStore.listFilter.withQuantity,
        sortField: (supplierStore.sortDesc) ? 'name' : undefined,
        sortDesc: (supplierStore.sortDesc === SORT_METHOD.ALPH_DESC)
    }))
    if (await loadingController.getTop()) hideLoading()
    if (await modalController.getTop()) modalController.dismiss()
}

const loadListContent = async (): Promise<void> => {
    await Promise.all([
        supplierStore.getLocationSupplier(locationId.value),
        listStore.getListItems(new GetListItemsParams({
            locationId: locationId.value,
            listId: listId.value,
            searchKey: supplierStore.searchQuery !== '' ? supplierStore.searchQuery : undefined,
            // category: listStore.listFilter.category !== '' ? listStore.listFilter.category : undefined,
            tags: listStore.activeFiltersIds.length !== 0 ? listStore.activeFiltersIds.join(',') : undefined,
            withQuantity: listStore.listFilter.withQuantity,
            sortField: (supplierStore.sortDesc) ? 'name' : undefined,
            sortDesc: (supplierStore.sortDesc === SORT_METHOD.ALPH_DESC)
        }))
    ])
    listStore.isLoaded.listItems = true

    await supplierStore.getLocationSupplier(locationId.value)

    await supplierStore.getCatalog({
        locationId: locationId.value,
        supplierId: props.supplierId ?? '',
    })
    supplierStore.isLoaded.catalog = true
}

const alertNoInternet = useAlert({
    header: t('alert.discardFormTitle'),
    message: t('alert.noInternet'),
    buttons: [{
        text: t('button.discardChanges'),
        handler: () => {
            supplierStore.isLoaded.catalog = false
            listStore.isLoaded.listItems = false
            loadListContent()
            persistentStore.offlineCache.deleteItem = []
            persistentStore.offlineCache.addItem = []
            persistentStore.offlineCache.patchItem = []
            persistentStore.offlineMode = false
            forceReload.value++
        }
    },
        {
            text: t('button.ok'),
            handler: () => {
                supplierStore.isLoaded.catalog = true
                listStore.isLoaded.listItems = true
                persistentStore.offlineMode = true
                forceReload.value++
            }
        }]
})

const changeDeleteMode = (event: IonToggleCustomEvent<ToggleChangeEventDetail>): void => {
    if (!list.value) return
    list.value.shouldDelete = event.detail.checked

    listStore.editList(list.value)
}

const toggleOfflineMode = async (event: IonToggleCustomEvent<ToggleChangeEventDetail>): Promise<void> => {
    persistentStore.offlineMode = event.detail.checked
    await showLoading(t('alert.syncing'))
    supplierStore.isLoaded.catalog = false
    listStore.isLoaded.listItems = false
    if (persistentStore.offlineMode) {
        if (!await pingRequest()) {
            persistentStore.offlineMode = false
            return
        }

        await Promise.all([
            listStore.getListItems(new GetListItemsParams({
                locationId: locationId.value,
                listId: listId.value,
                searchKey: undefined,
                category: undefined,
                tags: undefined,
                withQuantity: false,
                sortField: (supplierStore.sortDesc) ? 'name' : undefined,
                sortDesc: (supplierStore.sortDesc === SORT_METHOD.ALPH_DESC),
                take: 0
            })),
            supplierStore.getSupplierCategories(locationId.value, props.supplierId),
            listStore.getTags(locationId.value)
        ])

        persistentStore.offlineModeRoute = router.currentRoute.value.fullPath
        await hideLoading()
        listStore.isLoaded.listItems = true

        await supplierStore.getCatalog({
            locationId: locationId.value,
            supplierId: props.supplierId,
            includeList: listId.value,
            take: 0
        })
    } else {
        let jobFailed = false
        for (const item of persistentStore.offlineCache.deleteItem) {
            if (item.itemId.startsWith('new')) continue
            const response = await listStore.deleteItem(item.locationId, item.listId, item.itemId)

            if (!response) {
                hideLoading()
                jobFailed = true
            }
        }
        for (const item of persistentStore.offlineCache.addItem) {
            const response = await listStore.addListItem(item.locationId, item.listId, item.supplierItemId ?? '', item.amount ?? 0)

            if (!response) {
                hideLoading()
                jobFailed = true
            }
        }
        for (const item of persistentStore.offlineCache.patchItem) {
            const response = await listStore.patchListItem(item.locationId, item.listId, item.itemId, item.amount ?? 0, item.targetStock ?? 0)

            if (!response) {
                hideLoading()
                jobFailed = true
            }
        }
        if (jobFailed) return alertNoInternet.present()

        supplierStore.isLoaded.catalog = false
        listStore.isLoaded.listItems = false
        persistentStore.offlineCache.deleteItem = []
        persistentStore.offlineCache.addItem = []
        persistentStore.offlineCache.patchItem = []

        await loadListContent()
    }

    nextTick(() => {
        supplierStore.isLoaded.catalog = true
        listStore.isLoaded.listItems = true
    })

    await hideLoading()
}

const toggleReducedListDesign = (): void => {
    if (!list.value) return

    persistentStore.handleReducedDesign()
}

const resetList = async () => {
    const result = await listStore.resetListItems(locationId.value, listId.value)
    if (!result) return

    await listStore.getListItems(new GetListItemsParams({
        locationId: locationId.value,
        listId: listId.value,
        searchKey: listStore.searchQuery,
        manualSort: listStore.listFilter.sortDirection === SORT_METHOD.MANUAL
    }))

    window.dispatchEvent(new Event('reset-amount'))

    replaceToast({
        message: t('messages.list.amountReset'),
        id: 'amount-reset'
    })
}

const resetListCheck = () => {
    popAlertConfirm({
        message: t('messages.list.resetCheck'),
        handler: {
            ok: resetList
        }
    })
}

onMounted(() => {
    if (usePersistentStore().offlineMode) return
    if (props.supplierId) supplierStore.getSupplierCategories(locationId.value, props.supplierId)
    listStore.getTags(locationId.value)
})

return (_ctx: any,_cache: any) => {
  const _component_ion_text = _resolveComponent("ion-text")!

  return (_openBlock(), _createBlock(ModalControllerBase, { contentClass: "light-gradient-background" }, {
    header: _withCtx(() => [
      _createVNode(FilterHeader, {
        title: _ctx.$t('object.setting'),
        onBack: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalController).dismiss()))
      }, null, 8, ["title"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(IonAccordionGroup), { class: "px-1 pb-1" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonAccordion), { class: "my-1 setting-border grey4-light-background" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), {
                slot: "header",
                lines: "none",
                class: "grey4-light-background coral-coral-color fw-b accordion-90-deg grey-accordion-toggle"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(IonIcon), {
                      class: "purple-purple-color px-1 fs-30",
                      src: "assets/icon/filter.svg"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('titleRoute.filter')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(FilterInterface, {
                  style: {"height":"clamp(350px, calc(100vh - 330px), 550px)"},
                  tempCategory: tempCategory.value,
                  "onUpdate:tempCategory": _cache[1] || (_cache[1] = ($event: any) => ((tempCategory).value = $event)),
                  tempTags: tempTags.value,
                  "onUpdate:tempTags": _cache[2] || (_cache[2] = ($event: any) => ((tempTags).value = $event)),
                  withQuantity: withQuantity.value,
                  "onUpdate:withQuantity": _cache[3] || (_cache[3] = ($event: any) => ((withQuantity).value = $event)),
                  "sort-direction": tempSortDirection.value,
                  "onUpdate:sortDirection": _cache[4] || (_cache[4] = ($event: any) => ((tempSortDirection).value = $event)),
                  "own-categories": _unref(listStore).recommendedTags?.data,
                  onReset: resetChanges,
                  onApply: applyChanges,
                  "supplier-id": __props.supplierId,
                  "is-list": ""
                }, null, 8, ["tempCategory", "tempTags", "withQuantity", "sort-direction", "own-categories", "supplier-id"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonAccordion), { class: "mt-1 setting-border light-light-background" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), {
                slot: "header",
                lines: "none",
                class: "grey4-light-background coral-coral-color fw-b accordion-90-deg grey-accordion-toggle accordion-toggle-click"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(), _createBlock(_unref(IonToggle), {
                      color: _unref(ION_VARIANT).CORAL,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($event.stopPropagation())),
                      onIonChange: changeDeleteMode,
                      key: _unref(forceReload),
                      checked: list.value?.shouldDelete ?? true,
                      class: "accordion-toggle px-1 mr-2",
                      slot: "start"
                    }, null, 8, ["color", "checked"]))
                  ]),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('label.resetAmount')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.$t('label.resetProductQuantity')) + " ", 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(ButtonBase, { onClick: resetListCheck }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('button.resetAmount')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          (_unref(userStore).permission[_unref(PERMISSION_KEY).LIST_REMINDER_READ] && !_unref(persistentStore).offlineMode)
            ? (_openBlock(), _createBlock(_unref(IonAccordion), {
                key: 0,
                class: "my-1 setting-border grey4-light-background"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    lines: "none",
                    class: "grey4-light-background coral-coral-color fw-b accordion-90-deg grey-accordion-toggle"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_unref(IonIcon), {
                          class: "purple-purple-color px-1 fs-30",
                          slot: "start",
                          icon: _unref(alarmOutline)
                        }, null, 8, ["icon"])
                      ]),
                      _createVNode(_component_ion_text, { class: "purple-purple-color" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('titleRoute.orderNotificationTimer')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(OrderNotificationTimer, {
                      class: "custom-order-wecker",
                      "no-title": "",
                      style: {"min-height":"350px","height":"calc(100vh - 330px)"}
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(isApp)())
            ? (_openBlock(), _createBlock(_unref(IonAccordion), {
                key: 1,
                class: "mt-1 setting-border light-light-background"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    slot: "header",
                    lines: "none",
                    class: "grey4-light-background coral-coral-color fw-b accordion-90-deg grey-accordion-toggle accordion-toggle-click"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(), _createBlock(_unref(IonToggle), {
                          color: _unref(ION_VARIANT).CORAL,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => ($event.stopPropagation())),
                          onIonChange: toggleOfflineMode,
                          key: _unref(forceReload),
                          checked: _unref(persistentStore).offlineMode,
                          class: "accordion-toggle px-1 mr-2",
                          slot: "start"
                        }, null, 8, ["color", "checked"]))
                      ]),
                      _createVNode(_component_ion_text, { class: "purple-purple-color" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('label.offlineMode')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_ctx.$t('label.offlineMode1')) + " ", 1),
                    _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('label.offlineMode2')), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})